import { render, staticRenderFns } from "./authCode.vue?vue&type=template&id=6f6cb8e4&scoped=true"
import script from "./authCode.vue?vue&type=script&lang=js"
export * from "./authCode.vue?vue&type=script&lang=js"
import style0 from "./authCode.vue?vue&type=style&index=0&id=6f6cb8e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6cb8e4",
  null
  
)

export default component.exports